import React from 'react';

interface ThreatDetectionIconProps extends React.SVGProps<SVGSVGElement> {
  size?: number;
}

export const ThreatDetectionIcon: React.FC<ThreatDetectionIconProps> = ({
  size = 20,
  ...props
}) => {
  return (
    <svg
      fill="none"
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      height={size}
      width={size}
    >
      <path
        clipRule="evenodd"
        d="M12 11.125C12.4832 11.125 12.875 11.5168 12.875 12V12.01C12.875 12.4932 12.4832 12.885 12 12.885C11.5168 12.885 11.125 12.4932 11.125 12.01V12C11.125 11.5168 11.5168 11.125 12 11.125Z"
        fill="#B5BCC4"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M14.2095 8.55319C14.5513 8.21153 15.1053 8.21161 15.4469 8.55337C16.3609 9.46757 16.8743 10.7073 16.8743 12C16.8743 13.2927 16.3609 14.5324 15.4469 15.4466C15.1053 15.7884 14.5513 15.7885 14.2095 15.4468C13.8677 15.1052 13.8677 14.5511 14.2093 14.2094C14.7952 13.6233 15.1243 12.8286 15.1243 12C15.1243 11.1714 14.7952 10.3766 14.2093 9.79062C13.8677 9.44886 13.8677 8.89484 14.2095 8.55319Z"
        fill="#B5BCC4"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M17.0385 5.72432C17.3802 5.3826 17.9342 5.38258 18.2759 5.72428C19.1001 6.54841 19.7539 7.5268 20.1999 8.6036C20.6459 9.68039 20.8755 10.8345 20.8755 12C20.8755 13.1655 20.6459 14.3196 20.1999 15.3964C19.7539 16.4732 19.1001 17.4516 18.2759 18.2758C17.9342 18.6175 17.3802 18.6174 17.0385 18.2757C16.6968 17.934 16.6968 17.38 17.0385 17.0383C17.7002 16.3767 18.225 15.5912 18.5831 14.7267C18.9412 13.8623 19.1255 12.9357 19.1255 12C19.1255 11.0643 18.9412 10.1378 18.5831 9.27331C18.225 8.40885 17.7002 7.62337 17.0385 6.96175C16.6968 6.62005 16.6968 6.06603 17.0385 5.72432Z"
        fill="#B5BCC4"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M9.78684 8.55319C10.1286 8.89484 10.1287 9.44886 9.78703 9.79062C9.20118 10.3766 8.87207 11.1714 8.87207 12C8.87207 12.8286 9.20118 13.6233 9.78703 14.2094C10.1287 14.5511 10.1286 15.1052 9.78684 15.4468C9.44508 15.7885 8.89106 15.7884 8.5494 15.4466C7.63548 14.5324 7.12207 13.2927 7.12207 12C7.12207 10.7073 7.63548 9.46757 8.5494 8.55337C8.89106 8.21161 9.44508 8.21153 9.78684 8.55319Z"
        fill="#B5BCC4"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M6.95617 5.72432C7.29787 6.06603 7.29785 6.62005 6.95613 6.96175C6.29448 7.62337 5.76962 8.40884 5.41153 9.27331C5.05345 10.1378 4.86914 11.0643 4.86914 12C4.86914 12.9357 5.05345 13.8623 5.41153 14.7267C5.76962 15.5912 6.29448 16.3767 6.95613 17.0383C7.29785 17.38 7.29787 17.934 6.95617 18.2757C6.61447 18.6174 6.06045 18.6175 5.71873 18.2758C4.89456 17.4516 4.24079 16.4732 3.79475 15.3964C3.34871 14.3196 3.11914 13.1655 3.11914 12C3.11914 10.8345 3.34871 9.68039 3.79475 8.6036C4.24079 7.5268 4.89456 6.54841 5.71873 5.72428C6.06045 5.38258 6.61447 5.3826 6.95617 5.72432Z"
        fill="#B5BCC4"
        fillRule="evenodd"
      />
    </svg>
  );
};
